import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { commonservices } from "../../services/CommonServices";
import {
    Button,
    Col,
    Container,
    Dropdown,
    Form,
    Overlay,
    Popover,
    Row,
    Table,
    Tooltip,
} from "react-bootstrap";
import Editor, { DiffEditor, useMonaco, loader } from "@monaco-editor/react";
import { API_URL } from "../../services/APIRoute";
import Json from "../../assets/images/json.svg";

import { apiCall } from "../../services/AxiosService";
import { apiResponse } from "../../services/APIResponse";
import { toast } from "react-toastify";
import ObjectViewModel from "./FlowNewModels/ObjectViewModel";
import Plusicon from "../../assets/images/addicon.svg";
import deleteAction from "../../assets/images/deleteaction.svg";

const DataMapping = (props) => {
    const targetConfig = useRef([]);
    const handleShowConfigPopup = (e) => {
        setShowConfigPopup(!showConfigPopup);
    };
    const [AllFiles, setAllFiles] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [QueryTopPart, setQueryTopPart] = useState("");
    const [InputSampleFiles, setInputSampleFiles] = useState([]);
    const [showConfigPopup, setShowConfigPopup] = useState(false);
    const [configPopupPlacement, setConfigPopupPlacement] = useState("bottom-end");
    const [ObjData, setObjData] = useState("");
    const [ObjName, setObjName] = useState("");
    const [objError, setObjError] = useState(false);
    const [activeTab, setActiveTab] = useState(1);
    const [Parentmachinelst, setParentmachinelst] = useState([]);
    const [Childmachinename, setChildmachinename] = useState("");

    const [QueryRunResult, setQueryRunResult] = useState({
        message: "",
        iserror: false,
        data: [],
        isrunning: false,
        lastrunqyery: "",
    });

    const [QueryResult, setQueryResult] = useState([]);

    const [QueryFinalPart, setQueryFinalPart] = useState("");
    const [condition_list, setcondition_list] = useState([
        {
            parentmachine: "",
            name: "",
            expression: "",
            operation: "",
            value: "",
            condition: "AND",
        },
    ]);

    const updateConfigPopupPlacement = (targetElement) => {
        if (!targetElement) return;

        const rect = targetElement.getBoundingClientRect();
        const estimatedPopupHeight = 320;
        const safetyGap = 16;
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        const shouldOpenTop =
            spaceBelow < estimatedPopupHeight + safetyGap && spaceAbove > spaceBelow;

        setConfigPopupPlacement(shouldOpenTop ? "top-end" : "bottom-end");
    };

    function extractKeyAndType(arr) {
        return arr
            .map((item) => ({ key: item.key, type: item.type, value: item.value }))
            .sort((a, b) => a.key.localeCompare(b.key));
    }

    function compareKeyAndType(GeneratedData, SampleData) {

        const _GeneratedData = extractKeyAndType(GeneratedData);
        const _SampleData = extractKeyAndType(SampleData);
        // if (_GeneratedData.length !== _SampleData.length) return false;

        for (let i = 0; i < _SampleData.length; i++) {
            if (_SampleData[i].value !== null) {
                if (_SampleData[i].key) {
                    let KeyFind = _GeneratedData.filter((f) => f.key === _SampleData[i].key);
                    if (KeyFind && KeyFind.length > 0) {
                        if (_SampleData[i].type !== KeyFind[0].type) {
                            return false;
                        }
                    }
                }
                //if (_GeneratedData[i].key !== _SampleData[i].key || _GeneratedData[i].type !== _SampleData[i].type) {
                //    return false;
                //}
            }
        }
        return true;
    }

    useEffect(() => {
        const fetchData = async () => {
            let _AllFiles = [];
            let _lstParentMachineList = [];

            setChildmachinename(props.data.SelfMachine.machinename);
            if (props.data.SelfMachine.inputsamplefile) {
                let fd = await getKeyPaths(props.data.SelfMachine.inputsamplefile);
                if (fd.json) {
                    setInputSampleFiles([
                        {
                            filename: "Sample Input File",
                            value: JSON.stringify(fd.json, null, 2),
                            language: "json",
                            outputfilename: props.data.SelfMachine.outputfilename,
                            logo: props.data.SelfMachine.machinelogo,
                        },
                    ]);
                }
            }

            if (props.data.SelfMachine.input_data) {
                _AllFiles.push({
                    filename: "Input Parameters",
                    value: JSON.stringify(props.data.SelfMachine.input_data, null, 2),
                    language: "json",
                    outputfilename: props.data.SelfMachine.outputfilename,
                    logo: props.data.SelfMachine.machinelogo,
                });
            }

            for (let i = 0; i < props.data.ParentMachine.length; i++) {
                let json = "";
                if (props?.data?.ParentMachine[i]?.outputdata) {
                    json = JSON.parse(props?.data?.ParentMachine[i]?.outputdata);
                }
                else {
                    let fd = await getKeyPaths(
                        props.data.ParentMachine[i].outputsamplefile,
                        props.data.ParentMachine[i].machinename
                    );
                    if (fd.json) {
                        json = fd.json;
                    }
                }

                if (json) {
                    _AllFiles.push({
                        filename: props.data.ParentMachine[i].machinename,
                        value: JSON.stringify(json, null, 2),
                        language: "json",
                        outputfilename: props.data.ParentMachine[i].outputfilename,
                        logo: props.data.ParentMachine[i].machinelogo,
                    });
                }

                _lstParentMachineList.push({
                    text: props.data.ParentMachine[i].machinename,
                    value: props.data.ParentMachine[i].outputfilename
                        .replace(".json", "")
                        .trim(),
                });
            }

            let Query = "";
            let _QueryTopPart = "";
            let _QueryFinalPart = "";

            for (let i = 0; i < _AllFiles.length; i++) {
                Query = Query + 'SELECT * FROM "' + _AllFiles[i].filename + '";\n';

                let value = "$$" + _AllFiles[i].value + "$$";
                let filename = "$$$$#" + _AllFiles[i].outputfilename + "#$$$$";

                _QueryTopPart =
                    _QueryTopPart +
                    'DROP TABLE IF EXISTS "' +
                    _AllFiles[i].filename +
                    '"; CREATE TEMPORARY TABLE "' +
                    _AllFiles[i].filename +
                    '" (data jsonb);INSERT INTO "' +
                    _AllFiles[i].filename +
                    '"(data) VALUES (' +
                    value +
                    "::jsonb);\n";

                _QueryFinalPart =
                    _QueryFinalPart +
                    'DROP TABLE IF EXISTS "' +
                    _AllFiles[i].filename +
                    '"; CREATE TEMPORARY TABLE "' +
                    _AllFiles[i].filename +
                    '" (data jsonb);INSERT INTO "' +
                    _AllFiles[i].filename +
                    '"(data) VALUES (' +
                    filename +
                    "::jsonb);\n";
            }
            setQueryFinalPart(_QueryFinalPart);
            setQueryTopPart(_QueryTopPart);

            if (props.data.dataprofile_query) {
                if (props.data.dataprofile_query.input_find_query) {
                    Query = props.data.dataprofile_query.input_find_query;
                }
            }

            if (props.data.condition_list) {
                if (props.data.condition_list && props.data.condition_list.length > 0) {
                    setcondition_list(structuredClone(props.data.condition_list))
                }
            }

            _AllFiles.unshift({
                filename: "Query Editor",
                value: Query,
                language: "pgsql",
                outputfilename: "",
            });
            setAllFiles(_AllFiles);
            setParentmachinelst(_lstParentMachineList);
        };
        fetchData();
    }, [props.data]);

    const ObjectMap = ({ ObjectData, level = 0 }) => {
        return (
            <>
                {Object.keys(ObjectData).map((key) => {
                    const value = ObjectData[key];
                    let type;
                    if (Array.isArray(value)) {
                        type = "array";
                    } else if (value === null) {
                        type = "null";
                    } else {
                        type = typeof value;
                    }
                    return (
                        <>
                            <div className={"data-fields-inner"} style={{ "--level": level }}>
                                <span>{key}</span>
                                <label style={{ textTransform: "capitalize" }}>
                                    {type === "object" ? "Json" : type}
                                </label>
                            </div>
                            {type === "object" && (
                                <ObjectMap ObjectData={value} level={level + 1} />
                            )}
                        </>
                    );
                })}
            </>
        );
    };

    const getKeyPaths = async (filepath, MachineName) => {
        let keypaths_obj = { keypath: null, json: null };

        await fetch(filepath)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch the file from S3");
                }
                return response.json();
            })
            .then((data) => {
                keypaths_obj.json = data;
            })
            .catch((error) => { });

        return keypaths_obj;
    };

    const RunQuery = async () => {
        try {
            let ReqFile = AllFiles?.find((item) => item?.filename === "Query Editor");
            if (ReqFile) {
                setQueryRunResult({
                    message: "",
                    iserror: false,
                    data: [],
                    isrunning: true,
                    lastrunqyery: "",
                });

                let resData = await apiCall(
                    {
                        method: "POST",
                        url: API_URL.BASEURL + API_URL.DATAPROFILECHECKOUTPUT,
                        body: { q: QueryTopPart + ReqFile?.value },
                    },
                    true
                );
                let response = apiResponse(false, resData);

                if (response.isValidate) {
                    setQueryRunResult({
                        message: resData.message,
                        iserror: false,
                        data: resData.data,
                        isrunning: false,
                        lastrunqyery: ReqFile?.value,
                    });
                    if (resData.data?.length > 0) {
                        let ArrayData = [];
                        resData.data?.forEach((element) => {
                            ArrayData.push(JSON?.parse(element?.rows[0]?.data));
                        });
                        setQueryResult(ArrayData);
                    }
                } else {
                    setQueryRunResult({
                        message: resData.message,
                        iserror: true,
                        data: [],
                        isrunning: false,
                        lastrunqyery: ReqFile?.value,
                    });
                }
                setObjError(false);
            }
        } catch (error) { }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (QueryRunResult.data === null || QueryRunResult.data.length === 0) {
                RunQuery();
            }
        };
        fetchData();
    }, [AllFiles]);

    useEffect(() => {
        if (!showConfigPopup || activeIndex === null) return;

        const recalculatePlacement = () => {
            const targetElement = targetConfig.current[activeIndex]?.current;
            updateConfigPopupPlacement(targetElement);
        };

        recalculatePlacement();
        window.addEventListener("resize", recalculatePlacement);
        window.addEventListener("scroll", recalculatePlacement, true);

        return () => {
            window.removeEventListener("resize", recalculatePlacement);
            window.removeEventListener("scroll", recalculatePlacement, true);
        };
    }, [showConfigPopup, activeIndex]);

    function fnEditorTextChangeNew(value, event, EditorConfig) {
        if (EditorConfig === "Query Editor" && event.isFlush === false) {
            let _AllFiles = structuredClone(AllFiles);
            if (_AllFiles && _AllFiles.length > 0) {
                let filterdata = _AllFiles.filter((i) => i.filename === EditorConfig);
                if (filterdata && filterdata.length > 0) {
                    filterdata[0].value = value;

                    setAllFiles(_AllFiles);
                }
            }
        }
    }

    function fnSaveDataProfiles() {
        if (activeTab === 1) {
            let Message = "Query Output Structure Not Match With Sample Input File Structure";
            let SampleData = commonservices.getKeyPaths(
                JSON.parse(InputSampleFiles[0]?.value)
            );
            if (!QueryRunResult.iserror) {
                if (QueryRunResult.data && QueryRunResult.data.length > 0) {
                    if (QueryRunResult.data.length === 1) {
                        if (
                            QueryRunResult.data[0].rows &&
                            QueryRunResult.data[0].rows.length > 0
                        ) {
                            if (QueryRunResult.data[0].rows.length === 1) {
                                let GeneratedData = commonservices.getKeyPaths(
                                    JSON.parse(QueryRunResult.data[0].rows[0].data)
                                );
                                if (compareKeyAndType(GeneratedData, SampleData)) {
                                    Message = "Both structure match and saved successfully";
                                    props.fnSetDataProfiling(
                                        {
                                            data_query: QueryFinalPart,
                                            input_find_query: QueryRunResult.lastrunqyery,
                                        },
                                        props.data
                                    );
                                }
                            }
                        }
                    }
                }
            }
            if (Message === "Query Output Structure Not Match With Sample Input File Structure") {
                setObjError(true);
                toast.error(Message);
            } else {
                toast.success(Message);
            }
        }
    }

    function fnSaveCondition() {
        if (activeTab === 0) {
            let _condition_list = structuredClone(condition_list);
            let isAllConditionIsValid = true;
            let startIndex = props.conditionStartIndex || 0;

            if (_condition_list && _condition_list.length > 0) {
                for (let i = 0; i < _condition_list.length; i++) {
                    _condition_list[i].name = "C" + (startIndex + i);
                    let isValidForRun = true;
                    let output = { isvalid: false, output: null, error: "" };

                    if (
                        _condition_list[i].parentmachine &&
                        _condition_list[i].parentmachine !== ""
                    ) {
                    } else {
                        isValidForRun = false;
                        output.error += " , Select Parent Machine";
                    }

                    if (
                        _condition_list[i].expression &&
                        _condition_list[i].expression !== ""
                    ) {
                        if (_condition_list[i].expression.indexOf("data") >= 0) {
                        } else {
                            isValidForRun = false;
                            output.error += " , Expression must be with 'data' key";
                        }
                    } else {
                        isValidForRun = false;
                        output.error += " , Add Expression";
                    }

                    if (
                        _condition_list[i].operation &&
                        _condition_list[i].operation !== ""
                    ) {
                    } else {
                        isValidForRun = false;
                        output.error += " , Select Opration";
                    }

                    if (_condition_list[i].value && _condition_list[i].value !== "") {
                    } else {
                        isValidForRun = false;
                        output.error += " , Add Value";
                    }

                    if (isValidForRun) {
                        if (_condition_list[i].parentmachine.toLowerCase() === "loopstart-0-0-0") {
                            output = { isvalid: true, output: true, error: null };
                        }
                        else {
                            let filterData = AllFiles.filter(
                                (item) =>
                                    item.outputfilename ===
                                    _condition_list[i].parentmachine + ".json"
                            );
                            if (filterData && filterData.length > 0) {
                                if (filterData[0].value && filterData[0].value !== "") {
                                    let data = JSON.parse(filterData[0].value);
                                    if (data) {
                                        output = runCondition(data, _condition_list[i].expression);
                                    } else {
                                        output.error += " , Parent Machine Output Not Found";
                                    }
                                } else {
                                    output.error += " , Parent Machine Output Not Found";
                                }
                            } else {
                                output.error += " , Parent Machine Output Not Found";
                            }
                        }
                    }
                    if (output.error && output.error !== "") {
                        output.error = output.error
                            .split(",")
                            .map((s) => s.trim())
                            .filter((s) => s)
                            .join(", ");
                    }
                    _condition_list[i].output = output;
                }
            }

            if (_condition_list && _condition_list.length > 0) {
                for (let i = 0; i < _condition_list.length; i++) {
                    if (_condition_list[i].output.isvalid === false) {
                        isAllConditionIsValid = false;
                    }
                }
            }

            if (isAllConditionIsValid) {
                let keyToRemove = "output";

                _condition_list.forEach(obj => {
                    delete obj[keyToRemove];
                });

                if (_condition_list && _condition_list.length > 0) {
                    for (let i = 0; i < _condition_list.length; i++) {
                        if (i === 0) {
                            _condition_list[i].condition = "";
                        }
                        else {
                            if (_condition_list[i].condition && _condition_list[i].condition !== "") {
                            }
                            else {
                                _condition_list[i].condition = "OR";
                            }
                        }
                    }
                }

                setcondition_list(_condition_list);
                props.fnSetCondition(_condition_list, props.data);
                toast.success("Condition saved successfully");
            }
            else {
                setcondition_list(_condition_list);
            }
        }
    }

    function runCondition(data, condition) {
        let obj = { isvalid: false, output: null, error: null };
        try {
            const allowed = {
                data,
                len: (x) => x.length,
                sum: (arr) => arr.reduce((a, b) => a + b, 0),
                min: Math.min,
                max: Math.max,
            };

            const fn = new Function(...Object.keys(allowed), `return ${condition};`);

            let output = fn(...Object.values(allowed));
            if (output !== undefined) {
                obj = { isvalid: true, output: output, error: null };
            } else {
                obj = {
                    isvalid: false,
                    output: output,
                    error: "Invalid Expression OR Invalid Key",
                };
            }
        } catch (error) {
            obj = { isvalid: false, output: null, error: error.toString() };
        }
        return obj;
    }

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    const handleChange = (index, field, value) => {
        const newRows = [...condition_list];
        newRows[index][field] = value;
        setcondition_list(newRows);
    };

    const addconditionRow = () => {
        setcondition_list([
            ...condition_list,
            {
                parentmachine: "",
                name: "",
                expression: "",
                operation: "",
                value: "",
                condition: "AND",
            },
        ]);
    };
    const deleteConditionRow = (index) => {
        const newRows = [...condition_list];
        newRows.splice(index, 1);
        setcondition_list(newRows);
    };

    return (
        <Modal
            {...props}
            fullscreen={true}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
            className="rejected-comment-modal modal-fullscreen workflow-data-profile-modal"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <div>
                    <div className="d-flex gap-2 align-items-center">
                        <Modal.Title id="contained-modal-title-vcenter">
                            Data Profile
                        </Modal.Title>
                        <span className="machine-name-detail">
                            {props.data.SelfMachine.machinename}
                        </span>
                    </div>
                    <p className="data-profile-p mt-1">
                        Convert your machine output into your desired Machine “Machine Name”
                        input data
                    </p>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="data-profile-main">
                    <div className="data-profile-left">
                        <h3>Estimated Data Fields (Output File)</h3>

                        {AllFiles?.filter((item) => item?.filename !== "Query Editor")?.map(
                            (items, index) => {
                                if (!targetConfig.current[index]) {
                                    targetConfig.current[index] = React.createRef();
                                }
                                return (
                                    <div key={index}>
                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                            <small>
                                                <img src={items?.logo} alt="logo" height={"20px"} />
                                                <span>{items?.filename}</span>
                                            </small>
                                            <span>
                                                <img
                                                    className={"cursor-pointer"}
                                                    src={Json}
                                                    alt="View Json"
                                                    ref={targetConfig.current[index]}
                                                    onClick={(e) => {
                                                        const isSamePopupOpen =
                                                            showConfigPopup && activeIndex === index;

                                                        if (isSamePopupOpen) {
                                                            setShowConfigPopup(false);
                                                            return;
                                                        }

                                                        const targetElement =
                                                            targetConfig.current[index]?.current;
                                                        updateConfigPopupPlacement(targetElement);
                                                        setActiveIndex(index);
                                                        setObjData(items?.value);
                                                        setObjName(items?.filename);
                                                        e.preventDefault();
                                                        setShowConfigPopup(true);
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <div className="data-fields">
                                            <div className="data-fields-main">
                                                <ObjectMap ObjectData={JSON.parse(items?.value)} />
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        )}
                    </div>
                    <div className="data-profile-right">
                        <div className="custom-tabing">
                            <div
                                className={activeTab === 1 ? "single-tab active" : "single-tab"}
                                onClick={() => handleTabClick(1)}
                            >
                                {/* <img src={cardicon} alt="cardicon" /> */}
                                <span>Data Profile</span>
                            </div>
                            <div
                                className={activeTab === 0 ? "single-tab active" : "single-tab"}
                                onClick={() => handleTabClick(0)}
                            >
                                {/* <img src={listicon} alt="listicon" /> */}
                                <span>Condition</span>
                            </div>
                        </div>{" "}
                        {activeTab === 1 ? (
                            <>
                                <h2>desired Inputs</h2>
                                <div className="code-palette-grid">
                                    <div className="code-palette">
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "30vh",
                                                overflow: "auto",
                                                verticalAlign: "top",
                                            }}
                                        >
                                            {InputSampleFiles?.length > 0 && (
                                                <Editor
                                                    height="45vh"
                                                    language={InputSampleFiles[0].language}
                                                    value={InputSampleFiles[0].value}
                                                    options={{
                                                        readOnly: true,
                                                        minimap: { enabled: false },
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className={`code-palette ${objError ? "red-border" : ""}`}
                                    >
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "30vh",
                                                overflow: "auto",
                                                verticalAlign: "top",
                                            }}
                                        >
                                            {QueryRunResult && (
                                                <Editor
                                                    height="45vh"
                                                    language={"json"}
                                                    value={
                                                        QueryRunResult?.isrunning
                                                            ? "Query is running......."
                                                            : QueryRunResult?.iserror
                                                                ? QueryRunResult?.message
                                                                : JSON.stringify(QueryResult, null, 2)
                                                    }
                                                    options={{
                                                        readOnly: true,
                                                        minimap: { enabled: false },
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <h2 className="mt-2">Prepare your Inputs</h2>
                                <div className="code-palette position-relative">
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "30vh",
                                            overflow: "auto",
                                            verticalAlign: "top",
                                        }}
                                    >
                                        {AllFiles?.length > 0 && (
                                            <Editor
                                                height="45vh"
                                                language={
                                                    AllFiles?.find(
                                                        (item) => item?.filename === "Query Editor"
                                                    )?.language
                                                }
                                                value={
                                                    AllFiles?.find(
                                                        (item) => item?.filename === "Query Editor"
                                                    )?.value
                                                }
                                                // onMount={handleEditorDidMount}
                                                onChange={(value, event) =>
                                                    fnEditorTextChangeNew(value, event, "Query Editor")
                                                }
                                                options={{
                                                    readOnly: false,
                                                    minimap: { enabled: false },
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className="data-profile-btn">
                                        <button
                                            onClick={(e) => {
                                                RunQuery();
                                            }}
                                        >
                                            Run Query
                                        </button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="condition-tab-contain">
                                <div className="condition-tab-header">
                                    <h2>Condition for parent output</h2>
                                    <button onClick={addconditionRow} className="add-btn">
                                        <img src={Plusicon} alt="Plus Icon" />
                                        Add
                                    </button>
                                </div>
                                <div className="condition-card-list">
                                    {condition_list.map((row, index) => (
                                        <div
                                            key={index}
                                            className={`condition-card ${row?.output?.isvalid === false ? "error" : ""
                                                }`}
                                        >
                                            <div className="condition-form-box">
                                                <div className="condition-card-header">
                                                    <h6>
                                                        Condition - {index + 1}
                                                    </h6>
                                                </div>

                                                <div className="condition-card-body">
                                                    {index > 0 && (
                                                        <>
                                                            <Form.Group className="form-group" style={{ flex: "none" }}>
                                                                <Form.Label className="common-label form-label">
                                                                    Condition
                                                                </Form.Label>
                                                                <select
                                                                    value={row.condition}
                                                                    className="form-control"
                                                                    style={{ width: "100px" }}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            index,
                                                                            "condition",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="AND">AND</option>
                                                                    <option value="OR">OR</option>
                                                                </select>
                                                            </Form.Group>
                                                        </>
                                                    )}
                                                    <Form.Group className="form-group">
                                                        <Form.Label className="common-label form-label">
                                                            Select Machines
                                                        </Form.Label>
                                                        <select
                                                            value={row.parentmachine}
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    index,
                                                                    "parentmachine",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-control"
                                                        >
                                                            <option value="">Select Machine</option>
                                                            {Parentmachinelst.map((machine, index) => (
                                                                <option key={index} value={machine.value}>
                                                                    {machine.text}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </Form.Group>
                                                    <Form.Group className="form-group">
                                                        <Form.Label className="common-label form-label">
                                                            Expression
                                                        </Form.Label>
                                                        <input
                                                            type="text"
                                                            placeholder="Expression"
                                                            className="form-control"
                                                            value={row.expression}
                                                            onChange={(e) =>
                                                                handleChange(index, "expression", e.target.value)
                                                            }
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="form-group">
                                                        <Form.Label className="common-label form-label">
                                                            Select operation
                                                        </Form.Label>
                                                        <select
                                                            value={row.operation}
                                                            className="form-control"
                                                            onChange={(e) =>
                                                                handleChange(index, "operation", e.target.value)
                                                            }
                                                        >
                                                            <option value="">Select Operation</option>
                                                            <option value="==">==</option>
                                                            <option value="!=">!=</option>
                                                            <option value=">">{">"}</option>
                                                            <option value="<">{"<"}</option>
                                                            <option value=">=">{">="}</option>
                                                            <option value="<=">{"<="}</option>
                                                        </select>
                                                    </Form.Group>
                                                    <Form.Group className="form-group">
                                                        <Form.Label className="common-label form-label">
                                                            Value
                                                        </Form.Label>
                                                        <input
                                                            type="text"
                                                            placeholder="Value"
                                                            className="form-control"
                                                            value={row.value}
                                                            onChange={(e) =>
                                                                handleChange(index, "value", e.target.value)
                                                            }
                                                        />
                                                    </Form.Group>
                                                    <button
                                                        onClick={() => deleteConditionRow(index)}
                                                        className="delete-btn"
                                                    >
                                                        <img
                                                            src={deleteAction}
                                                            alt="deleteAction"
                                                            title="Delete"
                                                        />
                                                    </button>
                                                </div>
                                            </div>
                                            {row?.output?.isvalid === false && (
                                                <div className="error-message">
                                                    {row?.output?.error}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="grey-btn w-auto" type="reset" onClick={props.onHide}>
                    Close
                </button>
                {activeTab === 1 ? (
                    <button
                        className="blue-btn w-auto"
                        type="submit"
                        onClick={(e) => fnSaveDataProfiles()}
                    >
                        Save Data Profile
                    </button>
                ) : (
                    <button
                        className="blue-btn w-auto"
                        type="submit"
                        onClick={(e) => fnSaveCondition()}
                    >
                        Save Condition
                    </button>
                )}
            </Modal.Footer>
            {showConfigPopup && activeIndex !== null && (
                <Overlay
                    target={targetConfig.current[activeIndex]?.current}
                    show={showConfigPopup}
                    placement={configPopupPlacement}
                    container={document.body}
                    rootClose={true}
                    onHide={() => setShowConfigPopup(false)}
                    containerPadding={20}
                >
                    {(props) => (
                        <Popover id="popover-config" {...props}>
                            <Popover.Body style={{ padding: 0 }}>
                                <ObjectViewModel
                                    handleshowPopup={handleShowConfigPopup}
                                    data={ObjData}
                                    name={ObjName}
                                />
                            </Popover.Body>
                        </Popover>
                    )}
                </Overlay>
            )}
        </Modal>
    );
};

export default DataMapping;
